import { ApolloLink } from './ApolloLink';
export var concat = ApolloLink.concat;
//# sourceMappingURL=concat.js.map